import useAppStore from "@/context/store";
import { useEffect } from "react";
// 用于监听采集弹窗的浏览器前进后退事件
export default function usePinsPopstate() {
  useEffect(() => {
    const onPopstate = (data) => {
      const path = window.location.pathname;
      if (/^\/pins\/\d*$/.test(path)) {
        /**
         * 1.只有之前打开的是弹窗才需要设置currentPin
         * 2.弹窗的实现逻辑是url还是原url，只是as 变成了/pins/[pinId],所以判断data?.state?.url如果为/pins/
         * [pinId]开头则前进之后的路径为详情页而不是弹窗，所以不需要设置currentPin
         **/

        if (!/^\/pins\/\[pinId\]/.test(data?.state?.url)) {
          const pinId = path.replace("/pins/", "");
          useAppStore.setState({ currentPin: { pinId } });
        }
      } else {
        useAppStore.setState({ currentPin: null });
      }
    };

    window.addEventListener("popstate", onPopstate);

    return () => {
      window.removeEventListener("popstate", onPopstate);
    };
  }, []);
}
